export default "__VITE_ASSET__UEmoMnk0__"